// Generated by purs version 0.15.16
import * as App_Route from "../App.Route/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Web_Event_EventTarget from "../Web.Event.EventTarget/index.js";
import * as Web_HTML from "../Web.HTML/index.js";
import * as Web_HTML_Event_HashChangeEvent_EventTypes from "../Web.HTML.Event.HashChangeEvent.EventTypes/index.js";
import * as Web_HTML_Event_PopStateEvent_EventTypes from "../Web.HTML.Event.PopStateEvent.EventTypes/index.js";
import * as Web_HTML_History from "../Web.HTML.History/index.js";
import * as Web_HTML_Location from "../Web.HTML.Location/index.js";
import * as Web_HTML_Window from "../Web.HTML.Window/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Effect.bindEffect);
var map = /* #__PURE__ */ Data_Functor.map(Effect.functorEffect);
var when = /* #__PURE__ */ Control_Applicative.when(Effect.applicativeEffect);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe);
var bindFlipped = /* #__PURE__ */ Control_Bind.bindFlipped(Effect.bindEffect);
var replaceUrl = function (psi) {
    return function (url) {
        return psi.replaceState(Foreign.unsafeToForeign(Data_Unit.unit))(url);
    };
};
var replaceRoute = function (psi) {
    var $13 = replaceUrl(psi);
    return function ($14) {
        return $13(App_Route.routeUrl($14));
    };
};
var readLocation = function (v) {
    return v.locationState;
};
var pushUrl = function (psi) {
    return function (url) {
        return psi.pushState(Foreign.unsafeToForeign(Data_Unit.unit))(url);
    };
};
var pushRoute = function (psi) {
    var $15 = pushUrl(psi);
    return function ($16) {
        return $15(App_Route.routeUrl($16));
    };
};
var currentLocationState = function __do() {
    var win = Web_HTML.window();
    var loc = Web_HTML_Window.location(win)();
    var state = bind(Web_HTML_Window.history(win))(Web_HTML_History.state)();
    var pathname = Web_HTML_Location.pathname(loc)();
    var search = Web_HTML_Location.search(loc)();
    var hash = Web_HTML_Location.hash(loc)();
    var path = pathname + (search + hash);
    return {
        state: state,
        pathname: pathname,
        search: search,
        hash: hash,
        path: path
    };
};
var listenBrowserNavigation = function (callback) {
    return function __do() {
        var activeRef = Effect_Ref["new"](true)();
        var listenerRef = Effect_Ref["new"](Data_Maybe.Nothing.value)();
        var target = map(Web_HTML_Window.toEventTarget)(Web_HTML.window)();
        var cleanup = function __do() {
            var active = Effect_Ref.read(activeRef)();
            return when(active)(function __do() {
                Effect_Ref.write(false)(activeRef)();
                var mbListener = Effect_Ref.read(listenerRef)();
                return for_(mbListener)(function (listener) {
                    return function __do() {
                        Web_Event_EventTarget.removeEventListener(Web_HTML_Event_PopStateEvent_EventTypes.popstate)(listener)(false)(target)();
                        return Web_Event_EventTarget.removeEventListener(Web_HTML_Event_HashChangeEvent_EventTypes.hashchange)(listener)(false)(target)();
                    };
                })();
            })();
        };
        var listener = Web_Event_EventTarget.eventListener(function (v) {
            return function __do() {
                var active = Effect_Ref.read(activeRef)();
                return when(active)(function __do() {
                    cleanup();
                    return bindFlipped(callback)(currentLocationState)();
                })();
            };
        })();
        Effect_Ref.write(new Data_Maybe.Just(listener))(listenerRef)();
        Web_Event_EventTarget.addEventListener(Web_HTML_Event_PopStateEvent_EventTypes.popstate)(listener)(false)(target)();
        Web_Event_EventTarget.addEventListener(Web_HTML_Event_HashChangeEvent_EventTypes.hashchange)(listener)(false)(target)();
        return cleanup;
    };
};
export {
    listenBrowserNavigation,
    readLocation,
    pushUrl,
    replaceUrl,
    pushRoute,
    replaceRoute
};
//# sourceMappingURL=index.js.map
